var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useMemo } from 'react';
import { useIntl } from 'react-intl';
import isNil from 'lodash/isNil';
import Select from 'components/Select';
import messages from 'translations/shared';
import { FormGroup, FormSubHeading, FormGroupHeader, FormGroupContent, FormHelperText, } from '@petsly/shared-client';
var EmployeesField = function (_a) {
    var value = _a.value, error = _a.error, touched = _a.touched, onChange = _a.onChange, employees = _a.employees;
    var formatMessage = useIntl().formatMessage;
    var options = useMemo(function () {
        return employees.map(function (entry) { return ({
            value: entry.id,
            label: entry.name,
        }); });
    }, [employees]);
    var valuesFromIds = function (opts, ids) { return opts.filter(function (o) { return ids.includes(o.value); }); };
    return (_jsxs(FormGroup, __assign({ border: false }, { children: [_jsx(FormGroupHeader, { children: _jsx(FormSubHeading, { children: formatMessage(messages.employeesForService) }, void 0) }, void 0), _jsx(FormGroupContent, { children: _jsxs("div", __assign({ style: { marginBottom: 16 } }, { children: [_jsx(Select, { options: options, isMulti: true, closeMenuOnSelect: false, hideSelectedOptions: true, onChange: function (values) {
                                onChange(values.map(function (_a) {
                                    var value = _a.value;
                                    return value;
                                }));
                            }, placeholder: "", value: valuesFromIds(options, value) }, void 0), touched && !isNil(error) && (_jsx(FormHelperText, __assign({ error: true }, { children: error }), void 0))] }), void 0) }, void 0)] }), void 0));
};
var shouldRerender = function (prevProps, nextProps) {
    return (prevProps.value === nextProps.value &&
        prevProps.employees === nextProps.employees &&
        prevProps.touched === nextProps.touched &&
        prevProps.error === nextProps.error);
};
export default memo(EmployeesField, shouldRerender);
